<template>
  <div
    :class="$utils.isMobile() ? 'cpt-change-lang-m' : 'cpt-change-lang'"
    @click="switchLanguage"
  >
    <img class="img-box" v-if="$i18n.locale == 'en-US'" src="../assets/lang-en.png" alt="">
    <img class="img-box" v-else src="../assets/lang-zh.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'cpt-change-lang',
  data() {
    return {

    }
  },

  methods: {
    switchLanguage() {
			if (this._i18n.locale === 'zh-CN') {
				this.$i18n.locale = 'en-US';
			} else if (this._i18n.locale === 'en-US') {
				this.$i18n.locale = 'zh-CN';
			}
      localStorage.setItem('lang', this.$i18n.locale)
			location.reload()
		},
  },
}

</script>

<style lang='scss' scoped>
.cpt-change-lang{
  position: fixed;
  bottom: 150px;
  right: 50px;
  border-radius: 50%;
  border: 1px solid rgba(64, 126, 160, 0.5);
  display: flex;
  .img-box{
    width: 50px;
  }
}
.cpt-change-lang-m{
  position: fixed;
  bottom: 150px;
  right: 30px;
  border-radius: 50%;
  border: 1px solid rgba(64, 126, 160, 0.5);
  display: flex;
  .img-box{
    width: 40px;
  }
}
</style>